import {
    Container,
    FormInput,
    FormLabel,
    Modal,
    ModalBody,
    ModalHeader,
    Spacer,
    useModal,
    Island,
    Notice,
    Icon,
    Grid,
    Vr,
    IconButton,
    useLoading,
} from "@holta/ui";
import { SupplierDetails } from "./parts/SupplierDetails";
import { Header } from "./parts/Header";
import { SupplierContext, useSupplierContextProps } from "./context";
import { Sidebar } from "./parts/Sidebar";
import { Contacts } from "./parts/Contacts";
import { Addresses } from "./parts/Addresses";
import { Settings } from "./parts/Settings";
import { useMatch, usePathParams } from "raviger";
import React from "react";
import { initialiseNewSupplier, clearAll, loadSupplier } from "../../actions/editSupplier";
import { Ranges } from "./parts/Ranges";
import { Products } from "./parts/Products";
import { BaseProducts } from "./parts/BaseProducts";

export const Supplier = () => {
    const contextProps = useSupplierContextProps();
    const { closeAll } = useModal();
    const isNew = useMatch("/suppliers/new");
    const params = usePathParams('/suppliers/:id')
    const [initialised, setInitialised] = React.useState(false);
    const {openLoading, closeLoading} = useLoading()

    React.useEffect(() => {

        async function init(){
            if (isNew && !initialised) {
                initialiseNewSupplier();
                setInitialised(true);
            }
            else if(params?.id) {
                const to = setTimeout(() => {    
                    openLoading();
                }, 1000);
                await loadSupplier(params.id);
                clearTimeout(to);
                setInitialised(true);
                closeLoading(200);
            }
    
            else throw new Error("Supplier page not found");
        }

        init();

        return () => {
            clearAll();
            setInitialised(false);
        }
        
    }, [isNew, params?.id]);
   

    React.useEffect(() => {
        return () => {
            closeAll();
            clearAll();
        };
    }, []);

    if(initialised) {
        return (
            <SupplierContext.Provider value={{ ...contextProps }}>
                <Container style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column" }}>
                    <div>
                        <Header />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Spacer xs={[0, 2, 2, 2]} style={{ height: "100%" }}>
                            <Island p={0} style={{ height: "100%", overflow: "auto" }}>
                                <Grid.Row xs={{ align: "stretch" }} style={{ height: "100%" }}>
                                    <Grid.Col xs={{ cols: 3 }}>
                                        <Sidebar />
                                    </Grid.Col>
                                    <Vr />
                                    <Grid.Col xs={{ cols: 9 }}>
                                        {contextProps.tab === 0 && <SupplierDetails />}
                                        {contextProps.tab === 1 && <Contacts />}
                                        {contextProps.tab === 2 && <Addresses />}
                                        {contextProps.tab === 3 && <Ranges />}
                                        {contextProps.tab === 4 && <BaseProducts />}
                                        {contextProps.tab === 5 && <Products />}
                                        {contextProps.tab === 6 && <Settings />}
                                    </Grid.Col>
                                </Grid.Row>
                            </Island>
                        </Spacer>
                    </div>
                </Container>
            </SupplierContext.Provider>
        );
    }

    return null;
};
